module.exports = new __parcel__URL__("base_raid_surrender_btn.6bd7cb38.png").toString();